/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A request to validate booking details before actual booking
 * @export
 * @interface PreBookRequest
 */
export interface PreBookRequest {
    /**
     * Email address of individual booking the room
     * @type {string}
     * @memberof PreBookRequest
     */
    emailAddress: string;
    /**
     * Family name of individual booking the room
     * @type {string}
     * @memberof PreBookRequest
     */
    familyName: string;
    /**
     * The loyalty account ID of the user to use for this booking request
     * @type {string}
     * @memberof PreBookRequest
     */
    loyaltyAccountId?: string;
}

/**
 * Check if a given object implements the PreBookRequest interface.
 */
export function instanceOfPreBookRequest(value: object): value is PreBookRequest {
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    return true;
}

export function PreBookRequestFromJSON(json: any): PreBookRequest {
    return PreBookRequestFromJSONTyped(json, false);
}

export function PreBookRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emailAddress': json['email_address'],
        'familyName': json['family_name'],
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
    };
}

export function PreBookRequestToJSON(json: any): PreBookRequest {
    return PreBookRequestToJSONTyped(json, false);
}

export function PreBookRequestToJSONTyped(value?: PreBookRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email_address': value['emailAddress'],
        'family_name': value['familyName'],
        'loyalty_account_id': value['loyaltyAccountId'],
    };
}

